export default __webpack_public_path__ + "static/filedblob-3662b8e3766369dc2f7de6f58ac15850.png";